/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */


// product description accordion

var acc = document.getElementsByClassName("accordion_item_column");
var tabcontent = document.getElementsByClassName("accordion_item");
var i, j;
for (i = 0; i < acc.length; i++) {
  acc[i].onclick = function() {
      if(this.parentNode.classList == 'accordion_item'){
        for (j = 0; j < tabcontent.length; j++) {
            tabcontent[j].classList.remove("active");
        }
      }
      this.parentNode.classList.toggle("active");
  }
}

window.onload = function() {
  if(window.jQuery){
    console.log('jquery')
    if($('.CollectionInner__Sidebar').length > 0){
      $('.CollectionInner__Sidebar [data-action="toggle-collapsible"]').each(function(i){
        if(i == 0 || i == 1){
          $(this).attr('aria-expanded','true')
        }else{
          $(this).next('.Collapsible__Inner').hide();
        }
      })
    }
    $('.CollectionInner__Sidebar').on('click','[data-action="toggle-collapsible"]',function(){
      var thisaria = $(this).attr('aria-expanded')
      if(thisaria == 'false'){
        $(this).attr('aria-expanded','true')
        $(this).next('.Collapsible__Inner').show();
      }else{
        $(this).attr('aria-expanded','false')
        $(this).next('.Collapsible__Inner').hide();
      }
    })
  }else{
    console.log('jquery none')
  }
}


$(document).ready(function(){
  if ($(document).width() > 1240) {
    $(".Product__SlideItem > div").on('mousemove', function(evt) {
      let clone;
      if ($('.golddevclass[data-id="'+$(this).attr('data-id')+'"]').length < 1)
      {
        clone = $('<div></div>');
        clone.appendTo($('.Product__Gallery'));
        clone.attr('data-id', $('.golddevclass').length);
        $(this).attr('data-id', $('.golddevclass').length);
        $(clone).addClass('golddevclass');
        $(clone).css('position','absolute');
        clone.css('top', '40px');
        clone.css('left', $(this).find('img').width());
        clone.css({
          'width': $(this).find('img').width(),
          'height': $(this).find('img').height(),
          'background-image': 'url('+$(this).find('img').attr('data-original-src')+')',
          'background-size': ($(this).find('img').width()*2)+'px '+($(this).find('img').height()*2)+'px',
          'z-index': 4,
        });
      }
      else clone=$('.golddevclass[data-id="'+$(this).attr('data-id')+'"]');

      clone.show().css({
        'background-position': '-'+(evt.originalEvent.offsetX*1)+'px '+'-'+(evt.originalEvent.offsetY*1)+'px',
      });
    });

    $(".Product__SlideItem > div").mouseout(function(){
      $('.golddevclass').hide();
    });
    
    
    $(".Product__SlideItem > div").mouseover(function() {
      $('.Product__GalleryWrapper').css({
          'z-index': -1
      });
    });
    
    $(".Product__SlideItem > div").mouseout(function(){ 
      $('.Product__GalleryWrapper').css({
          'z-index': 1
      });
    });
    
    
//     $(".Product__SlideItem > div").on('mousemove', function(e){
//        $('#square').offset({
//          top: parseInt(e.offsetY),
//          left: parseInt(e.offsetX)
//        });
//     });
    
  }
});

// let circle = document.getElementById('square');
// const onMouseMove = (e) =>{
//   circle.style.left = e.offsetX + 'px';
//   circle.style.top = e.offsetY + 'px';
//   circle.offset({top: parseInt(e.pageY - circle.height() / 3),left: parseInt(e.pageX - circle.width() / -10)});
// }
// document.addEventListener('mousemove', onMouseMove);

